/**
 * Changes to the Mobi2Go Analytics API should be represented on the Help Center page:
 * https://support.mobi2go.com/hc/en-us/articles/360016210532-Mobi2Go-Analytics-API
 */

const Analytics = Mobi2Go.app.mixinEvents('Analytics', {});
const Helpers = Mobi2Go.helpers;
const { Customer } = Mobi2Go;
const { Order } = Mobi2Go;
const { Menu } = Mobi2Go;
const { UI } = Mobi2Go;

const EVENTS = (Analytics.EVENTS = {
    READY: 'READY',
    LAST_ORDER_LOADED: 'LAST_ORDER_LOADED',
    IDENTIFY_CUSTOMER: 'IDENTIFY_CUSTOMER',
    REGISTERED_CUSTOMER: 'REGISTERED_CUSTOMER',
    REMOVED_PRODUCT: 'REMOVED_PRODUCT',
    ADDED_PRODUCT: 'ADDED_PRODUCT',
    EDITED_PRODUCT: 'EDITED_PRODUCT',
    IDENTIFY_LOCATION: 'IDENTIFY_LOCATION',
    VIEWED_PRODUCT_CATEGORY: 'VIEWED_PRODUCT_CATEGORY',
    VIEWED_PRODUCT_MENU: 'VIEWED_PRODUCT_MENU',
    VIEWED_PRODUCT: 'VIEWED_PRODUCT',
    STARTED_CHECKOUT: 'STARTED_CHECKOUT',
    STARTED_PAYMENT: 'STARTED_PAYMENT',
    CREDIT_CARD_SAVED: 'CREDIT_CARD_SAVED',
    CONFIRMED_ORDER: 'CONFIRMED_ORDER',
    SPLIT_BILL: 'SPLIT_BILL',
});

function isConfirmed() {
    const last_purchase = Helpers.cookie.get('MOBI2GO_APP_GA_LAST_PURCHASE');

    // If we've already dispatched a purchase event for this order, return
    if (last_purchase && last_purchase === String(Order.getId())) {
        return true;
    }

    Helpers.cookie.set('MOBI2GO_APP_GA_LAST_PURCHASE', Order.getId(), 3600);
    return false;
}

Mobi2Go.bind({
    ready(state) {
        Analytics.trigger(EVENTS.READY, state);
    },
});

Customer.bind({
    createSuccess(customer) {
        Analytics.trigger(EVENTS.REGISTERED_CUSTOMER, customer);
    },
});

Order.bind({
    updateCustomer(customer) {
        Analytics.trigger(EVENTS.IDENTIFY_CUSTOMER, customer);
    },
});

Order.onReady(function() {
    Order.bind({
        addProduct(product) {
            Analytics.trigger(EVENTS.ADDED_PRODUCT, product);
        },
        removeProduct(product) {
            Analytics.trigger(EVENTS.REMOVED_PRODUCT, product);
        },
        updateLocation(location) {
            Analytics.trigger(EVENTS.IDENTIFY_LOCATION, location);
        },
        updateProgressPhase(phase) {
            const payment = Order.getPayment();

            if (phase === 'confirming' && payment.method === 'online') {
                Analytics.trigger(EVENTS.STARTED_PAYMENT, Order);
            }

            if (phase === 'confirmed') {
                if (!isConfirmed()) {
                    if (
                        payment.card_token_saving_enabled &&
                        payment.method === 'online'
                    ) {
                        Analytics.trigger(EVENTS.CREDIT_CARD_SAVED, Order);
                    }

                    Analytics.trigger(EVENTS.CONFIRMED_ORDER, Order);
                }
            }
        },
    });

    // Redirecting back from an external payment processor can bypass
    // order confirmation events
    if (Order.getProgressPhase() === 'confirmed') {
        const payment = Order.getPayment();

        if (!isConfirmed()) {
            if (
                payment.card_token_saving_enabled &&
                payment.method === 'online'
            ) {
                Analytics.trigger(EVENTS.CREDIT_CARD_SAVED, Order);
            }

            Analytics.trigger(EVENTS.CONFIRMED_ORDER, Order);
        }
    }

    UI.bind({
        showConfirmation() {
            Analytics.trigger(EVENTS.STARTED_CHECKOUT, Order);
        },
        lastOrderLoaded(lastOrderState) {
            Analytics.trigger(EVENTS.LAST_ORDER_LOADED, lastOrderState);
        },
    });
});

Menu.onReady(function() {
    // Many desktop apps display all products on one page
    // Do products impressions for all products rather than 'showCategory'
    if (!Mobi2Go.app.isMobileUI()) {
        Order.onReady(function() {
            if (areAllMenuProductsShowing()) {
                setTimeout(function() {
                    Order.bind('updateMenu', function(menu) {
                        Analytics.trigger(EVENTS.VIEWED_PRODUCT_MENU, menu);
                    });
                    Analytics.trigger(
                        EVENTS.VIEWED_PRODUCT_MENU,
                        Order.getMenu()
                    );
                }, 800); // Delay to avoid sending multiple events on page load
            } else {
                UI.bind('showCategory', function(menu_category_id) {
                    const menu_category = Menu.getCategories().getById(
                        menu_category_id
                    );
                    if (menu_category) {
                        Analytics.trigger(
                            EVENTS.VIEWED_PRODUCT_CATEGORY,
                            menu_category
                        );
                    }
                });
                Analytics.trigger(
                    EVENTS.VIEWED_PRODUCT_CATEGORY,
                    Order.getMenu()
                        .getCategories()
                        .first()
                );
            }
        });
    } else {
        // Product Impressions
        UI.bind('showCategory', function(menu_category_id) {
            const menu_category = Menu.getCategories().getById(
                menu_category_id
            );
            if (menu_category) {
                Analytics.trigger(
                    EVENTS.VIEWED_PRODUCT_CATEGORY,
                    menu_category
                );
            }
        });
    }

    // Product detail
    UI.bind('editProduct', function(product) {
        Analytics.trigger(EVENTS.EDITED_PRODUCT, product);
    });

    // SplitTheBill
    UI.bind('splitTheBill', function(order) {
        Analytics.trigger(EVENTS.SPLIT_BILL, order);
    });
});

/**-------------------------------------------------------------------------
 * Whether the UI displays all menu products or groups by category
 */
function areAllMenuProductsShowing() {
    if (areAllMenuProductsShowing.value !== undefined) {
        return areAllMenuProductsShowing.value;
    }

    return (areAllMenuProductsShowing =
        UI.views.menu_categories && UI.views.menu_categories.$el.is(':hidden'));
}

// Expose global
Mobi2Go.Analytics = Analytics;
